import { type ReactNode } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { useMemberDisplay } from '@/hooks/use-member-display';
import type {
  RaceBonusEntry,
  RaceBonusLeader,
} from '../hooks/use-race-bonus-current';
import { Marker, Track, pct } from './race-chip-bar';
import { GoalMarker } from './race-chip-goal';

function YouMarker({ cur, goal }: { cur: number; goal: number }): ReactNode {
  const { user } = useAuth();
  return (
    <Marker
      label="Tú"
      name={user?.first_name ?? 'Tú'}
      photo={user?.photo}
      progress={pct(cur, goal)}
      count={cur}
      self
    />
  );
}

function LeaderMarker({
  leader,
  goal,
}: {
  leader: RaceBonusLeader;
  goal: number;
}): ReactNode {
  const d = useMemberDisplay(leader);
  return (
    <Marker
      label={`Líder · ${d.name}`}
      name={d.name}
      photo={d.photo}
      progress={pct(leader.count, goal)}
      count={leader.count}
      self={false}
    />
  );
}

export function RaceActive({ race }: { race: RaceBonusEntry }): ReactNode {
  const { user } = useAuth();
  const goal = race.threshold;
  const cur = race.your_progress;
  const leaderIsMe = race.leader?.id === user?.id;
  return (
    <div className="relative mx-2 flex h-4 items-center">
      <Track
        yourPct={pct(cur, goal)}
        leaderPct={race.leader ? pct(race.leader.count, goal) : null}
      />
      {race.leader && !leaderIsMe && (
        <LeaderMarker leader={race.leader} goal={goal} />
      )}
      <YouMarker cur={cur} goal={goal} />
      <GoalMarker goal={goal} />
    </div>
  );
}
